/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";

import MakeAPICall from "../../apiCalls/common";

import {
  endCallByDoctorFromAdminApiRoute,
  exportRequestLogsApiRoute,
  getConsultRequestsApiRoute,
  removePatientEntryFromQueueApiRoute,
  removePatientFromQueueApiRoute,
  updateAppointmentStatusReasonApiRoute
} from "../../apiRoutes";

import { converToUtc, getFormattedDate, getFormattedTimeV2 } from "../../utils/dateTimeHelper";

import APP_CONSTANTS from "../../constants";

import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";
import CustomModal from "../../components/modal";
import RefreshButton from "../../components/refreshButton";
import DeviceDetails from "../../components/deviceDetails";

import { UncontrolledTooltip } from "reactstrap";
import Button from "../../components/button";
import { KeyboardDatePicker } from "@material-ui/pickers";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const ConsultRequestsPage = props => {
  // let history = useHistory();
  // const [excelSheetData, setExcelSheetData] = useState([]);
  // const csvDownRef = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [isBookedConsult, setIsBookedConsult] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [apiCallParams2, setApiCallParams2] = useState(null);
  const [patientsList, setPatientsList] = useState([]);
  const [showExitQueueModal, setShowExitQueueModal] = useState(false);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10,
    isBookedConsult
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [currSelPat, setCurrSelPat] = useState(null);
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");
  // const [patientsInQueueCount, setPatientsInQueueCount] = useState(0);
  // const [docInQueueCount, setDocInQueueCount] = useState(0);

  const tableHeaders = [
    {
      key: "payment",
      value: "Payment"
    },
    {
      key: "status",
      value: "Status"
    },
    {
      key: "patientId",
      value: "Patient UIN"
    },
    { key: "profilePicOri", value: "Patient Details" },
    { key: "patientDetails", value: "Date" },
    { key: "dateOfBirth", value: "Time" },
    { key: "gender", value: "Nature of Consult" },
    { key: "action", value: "Device Details" },
    { key: "marketing", value: "Marketing Source" }
  ];

  const [currSelItem, setCurrSelItem] = useState(null);
  const [showEndCallModal, setShowEndCallModal] = useState(false);

  const getPatientsList = () => {
    setIsProcessing(true);

    currFilters.isBookedConsult = isBookedConsult;
    if (startDate && endDate){
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();

      currFilters.startDate = converToUtc(startDate);
      currFilters.endDate = converToUtc(dt);
    }


    setApiCallParams({
      reqType: "GET",
      reqUrl: getConsultRequestsApiRoute,
      params: currFilters,
      successCallback: async res => {
        let list = [];
        await res.data.data.appointments.forEach(column => {
          if (column.status !== 8 && column.status !== 7) {
            let d = {};

            d._id = column._id;
            if (column.patientId != null) {
              d.patId = column.patientId._id;
              d.patientId = column.patientId.patientId;
              d.patientEmail = column.patientId.email;
              d.phoneNumber = column.patientId.phoneNumber;
              if (
                column.patientId.middleName === "" ||
                column.patientId.middleName === null ||
                column.patientId.middleName === undefined ||
                column.patientId.middleName === "undefined"
              ) {
                d.patientMiddle = " ";
              } else {
                d.patientMiddle = column.patientId.middleName;
              }
              d.patientName =
                column.patientId.firstName +
                " " +
                d.patientMiddle +
                " " +
                column.patientId.lastName;

              d.marketing =
                column.patientId &&
                column.patientId.address &&
                column.patientId.address.state
                  ? column.patientId.address.state
                  : "-";
              d.marketingHear =
                column.patientId && column.patientId.whereDidYouHearAboutUs
                  ? column.patientId.whereDidYouHearAboutUs
                  : "-";
            } else {
              d.patId = "#";
              d.patientId = "";
              d.patientMiddle = "";
              d.patientName = "";
              d.patientEmail = "";
              d.phoneNumber = "";
            }

            console.log(column)
            d.createdDate = getFormattedDate(column.createdAt);
            d.createdTime = getFormattedTimeV2(column.isBookedConsult? column.bookingTime: column.createdAt);
            d.appointmentId = column.appointmentId;

            if (column.consultId) {
              d.nature = column.consultId.consultName;
            } else {
              d.nature = column.consultNature;
            }

            if (column.deviceDetails) {
              d.deviceDetails = column.deviceDetails;
            } else {
              d.deviceDetails = "";
            }

            d.payment = "Private";

            if (column.isBulkBilled) {
              d.payment = column.isBulkBilled === true ? "Medicare" : "Private";
            } else if (column.bilable === false) {
              d.payment = "Non-Billable";
            }

            if (column.isBookedConsult) {
              d.payment += " Booking"
            }

            d.status = "In Queue";
            d.statusColor = "";

            if (column.status === 2 || column.status === 3) {
              d.status = "Connected";
              d.statusColor = "color-light-blue";
            } else if (column.status === 4) {
              d.status = "On Call";
              d.statusColor = "color-yellow";
            } else if (column.status === 5) {
              d.status = "Succeeded";
              d.statusColor = "color-green";
            } else if (
              column.status === 6 ||
              column.status === 9 ||
              column.status === 10 ||
              column.status === 11 ||
              column.status === 12 ||
              column.status === 13
            ) {
              d.status = "Cancelled";
              d.statusColor = "color-light-grey";
            } else if (column.status === 0) {
              d.status = "Booking";
              d.statusColor = "";
            }

            if (column.status === 4 || column.status === 5) {
              if (
                column.isPhoneCallUsed !== undefined &&
                column.isPhoneCallUsed === true
              ) {
                d.statusColor = "color-brown";
              }
            }

            if (
              column.haveConnectionIssue !== undefined &&
              column.haveConnectionIssue === true
            ) {
              d.status = "Connection Issue";
              d.statusColor = "color-pink";
            }

            if (
              column.markedunsuccess !== undefined &&
              column.markedunsuccess === true
            ) {
              d.status = "Refunded";
              d.statusColor = "color-red";
            }

            if (column.appointmentStatusReason !== undefined) {
              d.appointmentStatusReason = column.appointmentStatusReason;
            } else {
              d.appointmentStatusReason = null;
            }

            if (column.isStuckInQueue !== undefined) {
              d.isStuckInQueue = column.isStuckInQueue;
            } else {
              d.isStuckInQueue = false;
            }

            list.push(d);
          }
        });
        setPatientsList(list);
        setTotalRecords(res.data.data.count);
        // setPatientsInQueueCount(res.data.data.patientsInQueueTotal || 0);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        setErrModalText(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        );
        setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getPatientsList();
  }, [currFilters, startDate, endDate, isBookedConsult]);

  const displayExitQueueModal = pat => {
    setCurrSelPat(pat);
    setShowExitQueueModal(true);
  };

  const removePatientFromQueue = () => {
    setIsProcessing(true);
    setShowExitQueueModal(false);

    setApiCallParams({
      reqType: "GET",
      reqUrl: removePatientFromQueueApiRoute,
      params: {
        queueNoId: currSelPat._id,
        appointmentId: currSelPat._id
      },
      successCallback: res => {
        setIsProcessing(false);
        getPatientsList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        setErrModalText(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        );
        setShowErrModal(true);
        getPatientsList();
      }
    });
  };

  const removePatientEntryFromQueue = appointmentId => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: removePatientEntryFromQueueApiRoute,
      params: {
        appointmentId: appointmentId
      },
      successCallback: res => {
        setIsProcessing(false);
        getPatientsList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        setErrModalText(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        );
        setShowErrModal(true);
        getPatientsList();
      }
    });
  };

  const showSelEndCallModal = data => {
    setCurrSelItem(data);
    setShowEndCallModal(true);
  };

  // end call
  const endSelItemCall = () => {
    setShowEndCallModal(false);
    setIsProcessing(true);
    console.log("Selected consult to remove: ", currSelItem);
    var formData = new FormData();
    formData.append("appointmentId", currSelItem._id);
    formData.append("callStatus", "COMPLETE");

    setApiCallParams({
      reqType: "PUT",
      reqUrl: endCallByDoctorFromAdminApiRoute,
      dataObj: formData,
      timeout: 30000,
      successCallback: async res => {
        setIsProcessing(false);
        getPatientsList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrModalText("Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists.");
        //setShowErrModal(true);
        getPatientsList();
      }
    });
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.isBookedConsult = isBookedConsult;
    setCurrFilters(newFilter);
  };

  const setSelectedPatient = pat => {
    const auth = props.auth.user;
    window.open(
      APP_CONSTANTS.pmsURL +
      "/patient/patientDetails?accessToken=" +
      auth.accessToken +
      "&patientId=" +
      pat.id +
      "&searchType=" +
      auth.userType +
      "&adminName=" +
      auth.firstName +
      " " +
      auth.lastName,
      "_blank"
    );
  };

  const updateAppointmentStatusReason = (appointId, value) => {
    setIsProcessing(true);

    let namInitial = "";

    if (props.auth.user) {
      namInitial = props.auth.user.firstName[0] + props.auth.user.lastName[0];
    }

    setApiCallParams({
      reqType: "GET",
      reqUrl: updateAppointmentStatusReasonApiRoute,
      params: {
        appointmentId: appointId,
        reason: value,
        lastUpdatedInitial: namInitial
      },
      successCallback: res => {
        setIsProcessing(false);
        getPatientsList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        setErrModalText(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        );
        setShowErrModal(true);
        getPatientsList();
      }
    });
  };

  const refreshPatientDoctorData = async (event) => {
    if (event) {
      event.stopPropagation();
    }
    getPatientsList();
    // getDoctorQueueList();
  };

  const exportRequestLogs = e => {
    e.preventDefault();
    //Todo check dates
    if (startDate !== null && endDate !== null && startDate <= endDate) {
      setIsProcessing(true);
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();

      setApiCallParams({
        reqType: "POST",
        reqUrl: exportRequestLogsApiRoute,
        dataObj: { startDate: converToUtc(startDate), endDate: converToUtc(dt) },
        successCallback: async res => {
          setIsProcessing(false);

          if (res.data.data && typeof res.data.data === "string") {
            window.open(res.data.data, '_blank')
          } else {
            console.log("admin/patient/requestLogs data not string", res);
          }
        },
        failureCallback: err => {
          setIsProcessing(false);
        }
      });

    } else {
      setErrModalText("Please select a valid start date and end date");
      setShowErrModal(true);

    }


  };


  return (
    <div className="view-ticket-container patients-queue-page-container">
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
          setCurrSelPat(null);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        okayText="Confirm"
        cancelText="Cancel"
        openModal={showExitQueueModal}
        cancelEvent={() => {
          setShowExitQueueModal(false);
          setCurrSelPat(null);
        }}
        okayEvent={removePatientFromQueue}
        modalBodyContent={
          <p className="text-center mb-0">Exit Patient Queue</p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showEndCallModal}
        cancelEvent={() => {
          setShowEndCallModal(false);
          setCurrSelItem(null);
        }}
        okayEvent={endSelItemCall}
        modalBodyContent={
          <p className="text-center mb-0">Do you want to end this call?</p>
        }
      />
      <div className="d-flex flex-row flex-wrap">
        <h3>Consult Requests</h3>
        <span className="flex-grow-1"></span>
        <div className="d-flex flex-row align-items-end">
          <FormControlLabel
            control={
              <Checkbox
                name="isBookedConsult"
                className="ic-checkbox"
                onChange={e => setIsBookedConsult(e.target.checked)}
                checked={isBookedConsult}
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            }
            // style={{marginBottom: "-0.3em !important"}}
            className="mb-n1"
            label="Bookings"
            labelPlacement="end"
          />
          <KeyboardDatePicker
            name="startDate"
            style={{ width: "135px" }}
            autoOk
            variant="inline"
            mask="__-__-____"
            format="DD-MM-YYYY"
            label="Start Date"
            value={startDate}
            onChange={date => setStartDate(date)}
          />
          <KeyboardDatePicker
            name="endDate"
            style={{ width: "135px", marginLeft: "20px" }}
            autoOk
            variant="inline"
            mask="__-__-____"
            format="DD-MM-YYYY"
            label="End Date"
            value={endDate}
            onChange={date => setEndDate(date)}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button
            clickEvent={exportRequestLogs}
            title="Patient Queue Cap Reached CSV"
          ></Button>
        </div>

        <RefreshButton
          className="float-right mt-3"
          onClick={refreshPatientDoctorData}
        />
      </div>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortableTable={false}
          tabFilters={currFilters}
          disableSearchText={true}
          disableTopFilters={true}
        >
          {patientsList.map((pat, i) => (
            <tr key={i} className="row-no-hover-effect fix-row-height">
              <td>{pat.payment}</td>
              <td className={pat.statusColor + " position-relative"}>
                <b>{pat.status}</b>
                {(pat.status === "Refunded" ||
                  pat.status === "Cancelled" ||
                  pat.status === "Connection Issue") && (
                  <div style={{ color: "#212529" }}>
                    <TextField
                      className="appointment-reason-dropdown"
                      select
                      SelectProps={{
                        native: true
                      }}
                      value={
                        pat.appointmentStatusReason !== null
                          ? pat.appointmentStatusReason.reason
                          : null
                      }
                      onChange={e =>
                        updateAppointmentStatusReason(pat._id, e.target.value)
                      }
                    >
                      <option>Reason</option>
                      <option value="Contacting">Contacting</option>
                      <option value="Quit Queue">Quit Queue</option>
                      <option value="Poor Connection">Poor Connection</option>
                      <option value="Missed Call">Missed Call</option>
                      <option value="Software Issue">Software Issue</option>
                      <option value="Left VM & N">Left VM & N</option>
                      <option value="Other">Other</option>
                    </TextField>
                    <br />
                    {pat.appointmentStatusReason !== null && (
                      <Fragment>
                        <span>
                          {pat.appointmentStatusReason.lastUpdatedInitial}
                        </span>
                      </Fragment>
                    )}
                  </div>
                )}
                {pat.status !== "In Queue" &&
                  pat.status !== "Connected" &&
                  pat.status !== "On Call" &&
                  pat.isStuckInQueue === true && (
                    <i
                      style={{ color: "#bfbfbf", top: "3px", right: "6px" }}
                      onClick={() => {
                        removePatientEntryFromQueue(pat._id);
                      }}
                      className="fa fa-times fa-2x error exit-queue-icon"
                    ></i>
                  )}

                {(pat.status === "Connected" || pat.status === "On Call") && (
                  <i
                    onClick={() => showSelEndCallModal(pat)}
                    className="fa fa-times fa-2x error exit-queue-icon consult-req-exit-queue"
                  ></i>
                )}
              </td>
              <td>
                <a
                  className="pat-pms-custom-link"
                  onClick={e => {
                    e.stopPropagation();
                    setSelectedPatient({
                      id: pat.patId
                    });
                  }}
                  href="#"
                >
                  {pat.patientId}
                </a>
              </td>
              <td>
                <div className="d-flex flex-column position-relative">
                  <p className="mb-0">
                    <b>{pat.patientName}</b>
                  </p>
                  <a
                    className="high-z-index list-email"
                    href={"mailto:" + pat.patientEmail}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {pat.patientEmail}
                  </a>
                  <p className="mb-0">
                    <ICPhoneDisplay value={pat.phoneNumber} />
                  </p>
                  {(pat.status === "In Queue" || pat.status === "Booking") && (
                    <i
                      onClick={() => {
                        displayExitQueueModal(pat);
                      }}
                      className="fa fa-times fa-2x error exit-queue-icon"
                    ></i>
                  )}
                </div>
              </td>
              <td>{pat.createdDate}</td>
              <td>{pat.createdTime}</td>
              <td>{pat.nature}</td>
              <td>
                <DeviceDetails data={pat.deviceDetails} />
              </td>
              <td className="patientQueue-td-200px">
                <p className="mt-2">
                  <span className="font-weight-bold">State: </span>{" "}
                  {pat.marketing}
                </p>
                <p className="" id={"toolTipId" + i}>
                  {pat.marketingHear && pat.marketingHear.length > 38
                    ? pat.marketingHear.slice(0, 38) + "..."
                    : pat.marketingHear}
                </p>
                {pat.marketingHear && pat.marketingHear.length > 38 && (
                  <UncontrolledTooltip
                    placement="bottom"
                    target={"toolTipId" + i}
                    fade={true}
                  >
                    {pat.marketingHear ? pat.marketingHear : ""}
                  </UncontrolledTooltip>
                )}
              </td>
            </tr>
          ))}
        </CustomDataTable>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
      <MakeAPICall apiParam={apiCallParams2} />
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(ConsultRequestsPage);
